



































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import ImageUploader from '../../files/_components/imageUploader.vue';
import DatePicker from '../../../components/date-picker.vue';

@Component({
  components: {
    DatePicker,
    ImageUploader,
  },
})
export default class DlgCampaignTest extends Vue {
  private dialog: boolean = false;
  private customEmail = '';
  private loading = false;

  @Action('campaigns/sendTest') private sendTest!: any;

  @Prop() private campaignId!: string;

  private async sendEmail(recipient: string) {
    this.loading = true;
    await this.sendTest({id: this.campaignId, recipient});
    this.loading = false;
  }
}
